module.exports = {
          srcSet: __webpack_public_path__ + "8efedcb9490ca91aff0737c83000613c-36.png"+" 36w",
          images:[ {path: __webpack_public_path__ + "8efedcb9490ca91aff0737c83000613c-36.png",width: 36,height: 37}],
          src: __webpack_public_path__ + "8efedcb9490ca91aff0737c83000613c-36.png",
          toString:function(){return __webpack_public_path__ + "8efedcb9490ca91aff0737c83000613c-36.png"},
          
          width: 36,
          height: 37
        }